// Real-time visitor tracking utility
const API = process.env.REACT_APP_BACKEND_URL;

let sessionId = localStorage.getItem('visitor_session_id');
if (!sessionId) {
  sessionId = 'v_' + Math.random().toString(36).substring(2, 15);
  localStorage.setItem('visitor_session_id', sessionId);
}

let heartbeatInterval = null;

export const startVisitorTracking = () => {
  // Send heartbeat every 30 seconds
  const sendHeartbeat = async () => {
    try {
      await fetch(`${API}/api/visitors/heartbeat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          session_id: sessionId,
          page: window.location.pathname,
          user_agent: navigator.userAgent,
        }),
      });
    } catch (e) {
      // Silently fail
    }
  };

  // Send initial heartbeat
  sendHeartbeat();

  // Set up interval
  if (!heartbeatInterval) {
    heartbeatInterval = setInterval(sendHeartbeat, 30000);
  }

  // Send heartbeat on page visibility change
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      sendHeartbeat();
    }
  });

  // Send heartbeat on page navigation
  window.addEventListener('popstate', sendHeartbeat);
};

export const stopVisitorTracking = () => {
  if (heartbeatInterval) {
    clearInterval(heartbeatInterval);
    heartbeatInterval = null;
  }
};
